/*
 * 通用的请求接口。各个业务组件都应该利用此组件提供的接口去发起远程请求，这样便于统一设置主机地址、身份验证、出错处理等。
 */
import axios from 'axios'
import store from '@/store'

const service = axios.create({
  // baseURL: '',
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 5000 // request timeout
})

service.interceptors.request.use(
  config => {
    if (store.getters.token) {
      // 可以在头部带上token
      // config.headers['X-Token'] = getToken()
    }
    return config
  },
  error => {
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    // 取出真正的数据（剥去axios额外包的一层）
    const res = response.data

    // // 可以检查数据中自定义的响应码
    // if (res.code !== 20000) {
    //   return Promise.reject(new Error(res.message || 'Error'))
    // }

    // 返回真正的数据部分
    return res
  },
  error => {
    // 出错的处理
    console.log('err' + error)
    // Message({
    //   message: error.message,
    //   type: 'error',
    //   duration: 5 * 1000
    // })
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/api/.request.js